import Contact from '../../../../common/personnes/components/mini-form/contact/mini.form.contact.model';

export default class OffreDemandeController {
    static $inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$translate',
        'OffresCommunicationService',
        'OffresService',
        'notification',
        '_',
        'ModalService',
        '$uibModal',
        'CodeAutomatiqueService',
        'MassiaApplicationService',
        'ProspectsService',
        'PersonnesService',
        'RouterHistoryService'
    ];

    newContact = new Contact();

    constructor(
        $scope,
        $state,
        $stateParams,
        $translate,
        OffresCommunicationService,
        OffresService,
        notification,
        _,
        ModalService,
        $uibModal,
        CodeAutomatiqueService,
        MassiaApplicationService,
        ProspectsService,
        PersonnesService,
        RouterHistoryService
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.OffresCommunicationService = OffresCommunicationService;
        this.OffresService = OffresService;
        this.notification = notification;
        this.ModalService = ModalService;
        this._ = _;
        this.$uibModal = $uibModal;
        this.CodeAutomatiqueService = CodeAutomatiqueService;
        this.MassiaApplicationService = MassiaApplicationService;
        this.ProspectsService = ProspectsService;
        this.PersonnesService = PersonnesService;
        this.RouterHistory = RouterHistoryService;
    }

    async $onInit() {
        this.unregisterReinit = this.OffresCommunicationService.registerReinit(() => this.initForm());
        this.societes = await this.OffresService.getSocietes();
        this.hasBeenCreated = false;
        this.offre.demande.fromExternalForm = false;
        if (!this.offre.demande.idSociete) {
            this.offre.demande.idSociete = this.societes[0].id;
        }

        await this.loadClientsAvecCompteSurSociete();
        await this.loadContacts();
        await this.loadTgapExclures();

        if (this.$stateParams.prospect) {
            this.offre.demande.idProspect = this.$stateParams.prospect.id;
            this.offre.demande.prospect = this.$stateParams.prospect;
            if (this.$stateParams.prospect.contactId && !this.offre.demande.idContact) {
                this.offre.demande.idContact = this.$stateParams.prospect.contactId;
            }
            this.$stateParams.prospect = null;
        }
        this.code = await this.codeAuto();

        await this.getOffreDevise();

        const _this = this;
        this.$scope.$watch('$ctrl.offre.demande.client', function (newValue) {
            if (newValue != null) {
                _this.clientSelected = newValue;
                _this.offre.demande.idClient = newValue.id;
            }
        });
        this.$scope.$watch('$ctrl.offre.demande.prospect', function (newValue) {
            if (newValue != null) {
                _this.prospectSelected = newValue;
                _this.offre.demande.idProspect = newValue.id;
            }
        });
    }

    $onDestroy() {
        this.unregisterReinit();
        if (!this.offre.demande.fromExternalForm) {
            delete this.RouterHistory.offre;
        }
    }

    async codeAuto() {
        try {
            const code = await this.CodeAutomatiqueService.getCodeAutomatique(this.MassiaApplicationService.getApplication());

            const res = code.find((x) => x.domaineCode.toLowerCase() === 'offres'.toLowerCase());

            return res;
        } catch (err) {
            console.error(err);
        }
    }
    selectNewContact() {
        this.contacts.push({
            id: this.newContact.id,
            libelle: this.newContact.prenom + ' ' + this.newContact.nom
        });

        this.offre.demande.idContact = this.newContact.id;
    }

    async loadClientsAvecCompteSurSociete(search) {
        if (this.offre.demande.idSociete) {
            this.clients = await this.OffresService.getClientsAvecCompteSurSociete(this.offre.demande.idSociete, search);
        }

        angular.forEach(this.clients, function (client) {
            if (client.isGenerique == true) {
                client.libelle = client.libelle + ' (Générique)';
            }
        });

        return this.clients;
    }

    async loadProspects(valeur) {
        if (this.offre.demande.idSociete) {
            return (this.prospects = await this.OffresService.getProspectsBySociete(this.offre.demande.idSociete, valeur));
        }
    }

    async loadContacts() {
        if (!this.offre.demande.client) {
            return;
        }

        this.contacts = await this.OffresService.getContactsBySite(this.offre.demande.client.id);

        if (this.offre.demande.idProspect) {
            const selectedProspect = await this.ProspectsService.getProspectEnteteById(this.offre.demande.idProspect);
            if (selectedProspect.contactId && !this.offre.demande.idContact) {
                this.offre.demande.idContact = selectedProspect.contactId;
            }
        }
    }

    async changeProspect() {
        this.contacts = await this.OffresService.getContactsBySite(this.offre.demande.client.id);
        if (!this.offre.demande.idProspect) {
            this.offre.demande.idContact = null;
            return;
        }
        const selectedProspect = await this.ProspectsService.getProspectEnteteById(this.offre.demande.idProspect);
        if (selectedProspect.contactId) {
            this.offre.demande.idContact = selectedProspect.contactId;
        } else {
            this.offre.demande.idContact = null;
        }
    }

    async changeSociete() {
        this.offre.demande.client = null;
        this.loadContacts();
        this.getOffreDevise();
    }

    async changeClient() {
        if (!this.$stateParams.id) {
            console.log(this.offre.demande.client.isDuBatiment);
            this.offre.demande.isBatiment = this.offre.demande.client.isDuBatiment;
        }
        this.loadContacts();
        await this.loadTgapExclures();
    }

    async loadTgapExclures() {
        const clientId = this.offre.demande.client?.id;
        if (clientId) {
            this.offre.tgapExclures = await this.OffresService.getTgapExclureByClient(clientId, null);
        }
    }

    changeBatiment() {
        if (this.checkPrestationRep() && !this.offre.demande.isBatiment) {
            this.offre.demande.isBatiment = true;
            const modalInstance = this.ModalService.confirm({
                modalTitle: this.$translate.instant('OFFRES.VALIDATION_REP.TITLE'),
                modalMsg: this.$translate.instant('OFFRES.VALIDATION_REP.MESSAGE'),
                headerClass: 'modal-danger'
            });
            const that = this;
            modalInstance.result.then(function () {
                that.offre.demande.isBatiment = false;
            });
        }
    }

    checkPrestationRep() {
        var hasRep = false;
        for (let i = 0; i < this.offre.entete.propositions.length; i++) {
            const prop = this.offre.entete.propositions[i];
            for (let j = 0; j < prop.producteurs.length; j++) {
                const producteur = prop.producteurs[j];
                for (let k = 0; k < producteur.produits.length; k++) {
                    const produit = producteur.produits[k];
                    if (produit.isRep) {
                        hasRep = true;
                    }
                }
            }
        }
        return hasRep;
    }

    async getOffreDevise() {
        if (this.offre.demande.idSociete) {
            const selectedSociete = await this.OffresService.getSocieteById(this.offre.demande.idSociete);
            if (selectedSociete.paysId) {
                const pays = await this.OffresService.getPaysById(selectedSociete.paysId);
                this.offre.devise = pays.symboleDevise;
            }
        }
    }

    saveCurrentInRouterHistory() {
        this.RouterHistory.offre = this.offre;
        this.offre.demande.fromExternalForm = true;
    }
}
